export default __webpack_public_path__ + "static/media/com-facebook.8934792b.mp4";